import React from 'react';
import './Progress.css';

interface ProgressProps {
  value: number; // 0-100
  className?: string;
}

export const Progress: React.FC<ProgressProps> = ({ value, className = '' }) => {
  const clampedValue = Math.max(0, Math.min(100, value));
  
  return (
    <div className={`progress-container ${className}`}>
      <div 
        className="progress-bar" 
        style={{ width: `${clampedValue}%` }}
      />
    </div>
  );
};